module.exports = __webpack_public_path__ + "static/murat-243fe939ec9c5d294a347f73825cbae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/avatars/murat.jpg
// module id = 2508
// module chunks = 157636680307020